import { createRoot } from "react-dom/client"

import axios from "axios"
import { QueryClient, QueryClientProvider } from "react-query"

// Apps
import { MetronicI18nProvider } from "./_metronic/i18n/Metronici18n"
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import "./_metronic/assets/sass/style.scss"
import "./_metronic/assets/sass/plugins.scss"
import "./_metronic/assets/sass/style.react.scss"
import { AppRoutes } from "./app/routing/AppRoutes"
import { AuthProvider, setupAxios } from "./app/modules/auth"

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
import "moment/locale/fr"
import { fr } from "yup-locales"
import { setLocale } from "yup"
import "common/_metronic/assets/sass/general.scss"

setupAxios(axios)
setLocale(fr) // Set Yup local globally to FR

const queryClient = new QueryClient({
     defaultOptions: {
          queries: {
               retry: false,
               refetchOnWindowFocus: false,
          },
     },
})
const container = document.getElementById("root")

if (container) {
     createRoot(container).render(
          <>
               <QueryClientProvider client={queryClient}>
                    <MetronicI18nProvider>
                         <AuthProvider>
                              <AppRoutes />
                         </AuthProvider>
                    </MetronicI18nProvider>
                    {/*<ReactQueryDevtools initialIsOpen={false}/>*/}
               </QueryClientProvider>
          </>
     )
}
